import { JSX } from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

function ProfileEducationTab({ isMobile }: { isMobile: boolean }): JSX.Element {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'stretch', sm: 'center' },
          mb: { xs: 2, sm: 3 },
          gap: { xs: 1, sm: 0 },
        }}
      >
        <Typography variant={isMobile ? 'subtitle1' : 'h6'}>Education</Typography>
        <Button
          variant="outlined"
          startIcon={<Add />}
          fullWidth={isMobile}
          size={isMobile ? 'small' : 'medium'}
        >
          Add Education
        </Button>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          textAlign: 'center',
          py: { xs: 2, sm: 4 },
          fontSize: { xs: '0.8rem', sm: '0.875rem' },
        }}
      >
        No education added yet. Click &quot;Add Education&quot; to get started.
      </Typography>
    </Box>
  );
}

export { ProfileEducationTab };
